import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import cookie from "js-cookie";

export const locales: string[] = ["ko-KR", "en-US"];

const getAllLocales = locales.reduce((acc, cur) => {
  const curLang = require(`./${cur}`);
  acc = { ...acc, ...curLang.default };
  return acc;
}, {});

const { language } = navigator;

const { href } = window.location;

const urlLocale = locales.filter(item => href.toLowerCase().includes(item.toLowerCase())).shift();

const systemLocale = locales.filter(item => item.toLowerCase().includes(language.toLowerCase())).shift() || "en-US";

cookie.set("locale", urlLocale || cookie.get("locale") || systemLocale);

export const getDefaultLocale = () => {
  return cookie.get("locale") || systemLocale;
};

i18n.use(initReactI18next).init({
  lng: getDefaultLocale(),
  resources: getAllLocales,
  debug: false,
  interpolation: {
    escapeValue: false
  }
});

export const changeLang = (lang: string) => {
  const oldLang = getDefaultLocale();
  const newLang = lang;
  if (newLang !== null && oldLang !== newLang) {
    cookie.set("locale", newLang);

    i18n.changeLanguage(getDefaultLocale());

    const { location, history } = window;

    const changeUrl = location.href.replace(oldLang, newLang);

    if (typeof history.pushState != "undefined") {
      history.pushState(null, "", changeUrl);
    } else {
      location.href = changeUrl;
    }
  }
};

export default i18n;
